import { SchemaBatch } from '../interfaces'

export const pushData = async (
  data: SchemaBatch,
  url: string,
  keepalive: boolean = false,
) => {
  await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(data),
    keepalive,
  })
}
